<div *ngIf="optOutAlerts$ | async" class="mb-5">
  <div *ngFor="let optOutAlert of optOutAlerts">
    <div class="mb-2">
      <input class="form-check-input ms-1" type="checkbox" [(ngModel)]="optOutAlert.Value" [id]="optOutAlert.AlertId" required />
      <label class="registration-opt-out-form-check-label ps-4" [for]="optOutAlert.AlertId">
        {{ optOutAlert.AlertDescription }}
      </label>
      <br />
    </div>
  </div>
  <div class="registration-navigataion-button-container">
    <fgbcl-registration-navigation (nextButtonClicked)="submitStep()" [stepType]="stepType"></fgbcl-registration-navigation>
  </div>
</div>
